import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Select, Button, message } from "antd";
import { FetchDealers_api } from "../../Api";

const { Option } = Select;

export const SalesPersonFormDrawer = ({
  modalOpen,
  setModalOpen,
  editingRecord,
  form,
  handleSubmit,
  submitting,
}: any) => {
  const [dealers, setDealers] = useState<any[]>([]);
  const [isFetchingDealers, setIsFetchingDealers] = useState(false);

  useEffect(() => {
    if (modalOpen) {
      loadDealers();
    }
  }, [modalOpen]);

  const loadDealers = async () => {
    setIsFetchingDealers(true);
    try {
      const res: any = await FetchDealers_api(1, 100, "");
      if (res?.dealerData) {
        setDealers(res.dealerData);
      }
    } catch (error) {
      console.error("Failed to load dealers", error);
      message.error("Failed to load dealers");
    } finally {
      setIsFetchingDealers(false);
    }
  };

  return (
    <Drawer
      title={editingRecord ? "Edit Sales Person" : "Add New Sales Person"}
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      footer={null}
      destroyOnClose
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter name" }]}
        >
          <Input placeholder="Enter Name" />
        </Form.Item>

        <Form.Item
          label="Contact Number"
          name="contact_number"
          rules={[{ required: true, message: "Please enter contact number" }]}
        >
          <Input placeholder="Enter Contact Number" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { type: "email", message: "Please enter a valid email" },
            { required: true, message: "Please enter email" },
          ]}
        >
          <Input placeholder="Enter Email" />
        </Form.Item>

        <Form.Item
          label="Dealer"
          name="dealer_id"
          rules={[{ required: true, message: "Please select a dealer" }]}
        >
          <Select
            placeholder="Select Dealer"
            loading={isFetchingDealers}
            showSearch
            optionFilterProp="children"
            allowClear
          >
            {dealers.map((b: any) => (
              <Option key={b.id} value={b.id}>
                {b.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Status" name="status" initialValue={1}>
          <Select>
            <Option value={1}>Active</Option>
            <Option value={0}>Inactive</Option>
          </Select>
        </Form.Item>

        <div className="flex justify-end gap-2 mt-6 pt-4 border-t">
          <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={submitting}>
            {editingRecord ? "Update Sales Person" : "Save Sales Person"}
          </Button>
        </div>
      </Form>
    </Drawer>
  );
};
